/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BillingContact } from './';
import {
    BillingContactFromJSON,
    BillingContactFromJSONTyped,
    BillingContactToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalEntityBillingContactResource
 */
export interface LegalEntityBillingContactResource {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityBillingContactResource
     */
    legalEntityId: string;
    /**
     * 
     * @type {BillingContact}
     * @memberof LegalEntityBillingContactResource
     */
    billingContact: BillingContact;
}

/**
 * Check if a given object implements the LegalEntityBillingContactResource interface.
 */
export function instanceOfLegalEntityBillingContactResource(value: object): value is LegalEntityBillingContactResource {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('billingContact' in value) || value['billingContact'] === undefined) return false;
    return true;
}

export function LegalEntityBillingContactResourceFromJSON(json: any): LegalEntityBillingContactResource {
    return LegalEntityBillingContactResourceFromJSONTyped(json, false);
}

export function LegalEntityBillingContactResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityBillingContactResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'billingContact': BillingContactFromJSON(json['billingContact']),
    };
}

export function LegalEntityBillingContactResourceToJSON(value?: LegalEntityBillingContactResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntityId': value['legalEntityId'],
        'billingContact': BillingContactToJSON(value['billingContact']),
    };
}

